import type { Loading } from "@/lib/loading"

export const processJustLoaded = (
  processId: Loading.ProcessId,
  { loading: before }: { loading: Loading.ContextData },
  { loading: after }: { loading: Loading.ContextData }
): boolean => {
  return (
    before.processes[processId].loading && !after.processes[processId].loading
  )
}
